import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { fetchCollaborationById, resetSelectedCollaboration } from '../store/slices/collaborationSlice';
import CollaborationShowcaseModal from '../components/collaboration/CollaborationShowcaseModal';
import LoadingSpinner from '../components/common/LoadingSpinner';

const CollaborationDetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { selectedCollaboration, loading, error } = useAppSelector((state) => state.collaboration);

  useEffect(() => {
    if (id) {
      dispatch(fetchCollaborationById(id));
    }
    return () => {
      dispatch(resetSelectedCollaboration());
    };
  }, [dispatch, id]);

  const handleClose = () => {
    navigate('/dashboard');
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Error</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/dashboard')}
            className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  if (!selectedCollaboration) {
    return null; // Or some placeholder
  }

  // Render the modal. Since it's a page, we might want to render it without the backdrop if possible,
  // but CollaborationDetailModal is built as a modal.
  // For now, we'll let it render as a modal over a blank background.
  return (
    <div className="min-h-screen bg-gray-100">
      <CollaborationShowcaseModal
        collaboration={selectedCollaboration}
        onClose={handleClose}
      />
    </div>
  );
};

export default CollaborationDetailsPage;
